export const NULL_ENCODED_VALUE = '%00';
export const COUNTRY_NULL_VALUE_PROPERTY = { value: NULL_ENCODED_VALUE, label: 'Not Available' };
export const FIELD_ALLOWED_FOR_NULL_VALUES = ['country', 'appIDs'];

export const AXN_COUNTRY_NULL_PROPERTY = {
    alpha2: COUNTRY_NULL_VALUE_PROPERTY.value,
    alpha3: '',
    code: '',
    id: '',
    name: COUNTRY_NULL_VALUE_PROPERTY.label,
    region: '',
    subregion: ''
}
